export default function PhilosophySection() {
  return (
    <section id="philosophy" className="py-20 bg-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">企業理念</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="mb-12">
              <h3 className="text-3xl font-bold mb-6 text-blue-300">
                「仕組みで、未来をデザインする。」
              </h3>
              <p className="text-lg text-blue-100 leading-relaxed mb-8">
                中山キャピタルは、投資・教育・コンサルティング・物流支援といった複数の事業領域を横断し、
                「資産を生み出す仕組み」の設計と構築を行う企業です。
              </p>
            </div>

            <div className="space-y-8">
              <div className="bg-blue-800 p-6 rounded-lg">
                <h4 className="text-xl font-bold mb-3 text-blue-300">使命</h4>
                <p className="text-blue-100">
                  世界に通用する「資産創造の仕組み」を日本から発信する。
                </p>
              </div>

              <div className="bg-blue-800 p-6 rounded-lg">
                <h4 className="text-xl font-bold mb-3 text-blue-300">ビジョン</h4>
                <p className="text-blue-100">
                  実業と金融をつなぎ、企業と個人が共に成長できるサステナブルな資産を形成するエコシステムを構築する。
                </p>
              </div>
            </div>
          </div>

          <div>
            <div className="bg-blue-800/50 p-6 rounded-lg">
              <h4 className="text-xl font-bold mb-4 text-blue-300">価値観</h4>
              <ul className="space-y-3 text-blue-100">
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-300 mr-3 mt-1"></i>
                  誠実な経営と透明性のある運営
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-300 mr-3 mt-1"></i>
                  構造的思考と長期的視野
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-300 mr-3 mt-1"></i>
                  挑戦を恐れず、変化に適応する力
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-300 mr-3 mt-1"></i>
                  成長を共有し、社会的価値を高める
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
